import dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc';
import timezone from 'dayjs/plugin/timezone';
import relativeTime from 'dayjs/plugin/relativeTime';
import customParseFormat from 'dayjs/plugin/customParseFormat';
import duration from 'dayjs/plugin/duration';
import isSameOrBefore from 'dayjs/plugin/isSameOrBefore';
import isSameOrAfter from 'dayjs/plugin/isSameOrAfter';

// Extend dayjs with plugins
dayjs.extend(utc);
dayjs.extend(timezone);
dayjs.extend(relativeTime);
dayjs.extend(customParseFormat);
dayjs.extend(duration);
dayjs.extend(isSameOrBefore);
dayjs.extend(isSameOrAfter);

// Note: isBefore and isAfter are built-in methods in dayjs, not plugins
// They are available as: dayjs().isBefore() and dayjs().isAfter()

/**
 * Configured dayjs instance with common plugins
 * Use this instead of moment.js for date operations
 * 
 * Note: AntDesign v3 still requires moment internally,
 * but we use dayjs in application code for better performance
 */
export default dayjs;
